import { render, staticRenderFns } from "./LeadsInvoice.vue?vue&type=template&id=74d5fa08&"
import script from "./LeadsInvoice.vue?vue&type=script&lang=js&"
export * from "./LeadsInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports